import React, { ReactChild, CSSProperties, PureComponent } from 'react';
import { PopOver, OverlayTrigger, Button, Icon } from '@tencent/spaui';
import dayjs from 'dayjs';
import classnames from 'classnames';
import { saveCombinedValue, getFromCombinedValue } from '@/utils/storage';
import { FLAGS } from '@/constants/Constants';

import './index.less';

type PlaceMode = 'top' | 'right' | 'bottom' | 'left';
interface GuidetipProps {
  /**
 * 唯一标识，用于存储
 */
  markKey: string;
  /**
   * 内容
   */
  content: string | ReactChild;
  /**
   * 子元素
   */
  children: ReactChild;
  /**
   * 展示次数
   */
  showCount?: number;
  /**
   * 显示隐藏按钮
   */
  showClose?: boolean;
  /**
 * 标题
 */
  title?: string;
  /**
   * 位置
   */
  placement?: PlaceMode;
  /**
   * 点击事件
   */
  onConfirm?: () => void;
  /**
   * 点击事件
   */
  onClose?: () => void;
  /**
   * 样式
   */
  style?: CSSProperties;
  /**
   * 开始展示时间，在此之前不展示
   */
  startDate?: string;
  /**
   * 过期时间，过期后不展示，可为空
   */
  expires?: string;
  /**
   * 是否黑色背景
   */
  dark?: boolean;

}
interface GuideTipState {
  showedCount: number
  isExpired: boolean
  startDateEnable: boolean
}
const closeButtonStyle: any = {
  position: 'absolute',
  right: '10px',
  top: '10px',
  cursor: 'pointer',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
// 从聚合value中取值
function getCountByKey(key: any) {
  return +getFromCombinedValue(FLAGS.GUIDE_TIP_STORAGE.GLOBAL_KEY, key, { defaultValue: 0 });
}
export class GuideTip extends PureComponent<GuidetipProps, GuideTipState> {
  static defaultProps = {};
  constructor(props: GuidetipProps) {
    super(props);
    this.state = {
      showedCount: getCountByKey(this.props.markKey),
      isExpired: this.getIsExpired(),
      startDateEnable: this.getStartDateEnable(),
    };
  }
  handleAddCount = () => {
    saveCombinedValue(FLAGS.GUIDE_TIP_STORAGE.GLOBAL_KEY, this.props.markKey, this.state.showedCount + 1);
    this.setState({
      showedCount: getCountByKey(this.props.markKey),
    });
  };
  // 如果开始时间不存在直接返回true，如果存在需要对比是否到达开始时间,到达后就返回true,渲染到页面上
  getStartDateEnable = () => {
    return !this.props.startDate ? true : !dayjs().isBefore(dayjs(this.props.startDate));
  };

  getIsExpired() {
    return this.props.expires ? dayjs().isAfter(dayjs(this.props.expires), 'day') : false;
  }
  render() {
    const { style, title, showClose, onClose, content, onConfirm, placement, children, showCount = 1, dark } = this.props;
    const { showedCount, isExpired, startDateEnable } = this.state;
    const popover = (
      <PopOver className={classnames('guide-tip-dark', { dark })} style={{ ...style }}>
        <div className="guide-tip-dark-header" style={{ position: 'relative' }}>
          <span>{title}</span>
          {showClose ? (
            <div
              style={closeButtonStyle}
              onClick={() => {
                this.handleAddCount();
                if (onClose) {
                  onClose();
                }
              }}
              className="guide-tip-close"
            >
              <Icon style={{ width: '13px' }} name="close-normal-outlined" />
            </div>
          ) : null}
        </div>
        <div className="guide-tip-dark-content">{content}</div>
        <div className="guide-tip-dark-footer">
          <Button
            displayType="primary"
            size="small"
            style={{ borderRadius: '4px' }}
            onClick={() => {
              this.handleAddCount();
              if (onConfirm) {
                onConfirm();
              }
            }}
          >
            我知道了
          </Button>
        </div>
      </PopOver>
    );

    return (
      <OverlayTrigger show={startDateEnable && !isExpired && showedCount < showCount} placement={placement} overlay={popover}>
        <div>{children}</div>
      </OverlayTrigger>
    );
  }
}
GuideTip.defaultProps = {
  showCount: 1,
  showClose: false,
  startDate: '',
  expires: '',
  markKey: '',
  dark: true,
};
export default GuideTip;

